const VisaLogoIcon = ({ width = 60, height = 20, ...props }) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 60 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M24.1753 19.2642L27.6435 0.799805H32.584L29.1153 19.2642H24.1753Z"
                fill="white"
            />
            <path
                d="M45.0647 1.29102C44.0756 0.891602 42.4272 0.450195 40.3195 0.450195C35.3398 0.450195 31.7541 2.97383 31.7322 6.62891C31.6978 9.30977 34.1897 10.8016 36.0616 11.6875C38.0037 12.5859 38.681 13.1672 38.681 13.9641C38.6685 15.1813 37.1647 15.7422 35.7678 15.7422C33.8478 15.7422 32.8116 15.4805 31.2372 14.8117L30.5941 14.5188L29.9035 18.8672C31.0491 19.3859 33.1678 19.8406 35.3616 19.8594C40.6241 19.8594 44.1441 17.3672 44.1785 13.4828C44.1941 11.3703 42.8441 9.74102 40.0116 8.4125C38.251 7.56406 37.1522 7.00039 37.1522 6.13906C37.1647 5.35469 38.0541 4.55781 40.0241 4.55781C41.616 4.52656 42.7941 4.91406 43.6991 5.31211L44.1347 5.50938L44.8116 1.29102H45.0647Z"
                fill="white"
            />
            <path
                d="M50.4534 12.3672C50.8359 11.2891 52.4046 7.18594 52.4046 7.18594C52.3796 7.22969 52.8296 6.05469 53.0796 5.36094L53.4215 6.97188C53.4215 6.97188 54.3484 11.4141 54.5515 12.3672H50.4534ZM56.8265 0.799805H52.9046C51.7046 0.799805 50.7965 1.11406 50.2746 2.36406L42.5546 19.2641H47.8171C47.8171 19.2641 48.7078 16.8922 48.8859 16.4109C49.4359 16.4109 54.5796 16.4172 55.2734 16.4172C55.4046 17.0359 55.8546 19.2641 55.8546 19.2641H60.5546L56.8265 0.799805Z"
                fill="white"
            />
            <path
                d="M19.4062 0.799805L14.5562 13.425L14.0531 10.7797C13.2156 7.88281 10.5187 4.72344 7.5 3.14844L11.9437 19.2516H17.2375L25.1062 0.799805H19.4062Z"
                fill="white"
            />
            <path
                d="M9.28125 0.799805H0.0875001L0 1.23418C6.38125 2.84824 10.7281 6.58105 12.4437 10.7797L10.6969 2.38105C10.4094 1.15168 9.51563 0.837305 8.34063 0.799805H9.28125Z"
                fill="white"
            />
        </svg>
    )
}

export default VisaLogoIcon
